import { Icon } from '@openeducation/oe-rn-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import FeedbackResponse from './feedback-response';
import ThemedText2 from '../../../components/themed-text-2';
import { useColors } from '../../../hooks';
import { Button } from '../../button/button';

export default function FeedbackError({ onClose, onTryAgain }) {
  const { t } = useTranslation();
  const colors = useColors();
  return (
    <FeedbackResponse
      icon={() => (
        <Icon
          type="solid"
          name="exclamation-triangle"
          size={40}
          color={colors.error}
        />
      )}
      onClose={onClose}
    >
      <ThemedText2 fontWeightStyle="bold" style={styles.text}>
        {t('errors.unablePerformAction')}
      </ThemedText2>
      <Button
        onPress={onTryAgain}
        containerStyle={{
          backgroundColor: colors.grayLight,
        }}
        textStyle={[
          styles.tryAgainButtonText,
          {
            color: colors.error,
          },
        ]}
      >
        {t('mobile.feedback.reportBug.tryAgain')}
      </Button>
    </FeedbackResponse>
  );
}

const styles = StyleSheet.create({
  text: {
    paddingVertical: 30,
    paddingHorizontal: 20,
    textAlign: 'center',
    fontSize: 20,
  },
  tryAgainButtonText: {
    fontSize: 16,
  },
});
